export const getStyled = (theme) => ({
  root: {
    display: 'flex',
    flexWrap: 'wrap',
  },

  multFieldLine: {
    display: 'flex',
    '& > *:not(:last-child)': {
      marginRight: theme.spacing(1),
    },
  },
  cancelButton: {
    color: '#FFF',
    backgroundColor: theme.custom.colors.cancelButton,
  },

  btnWrapper: {
    position: 'relative',
    color: '#FFF',
    backgroundColor: theme.custom.colors.confirmButton,
  },

  buttonProgress: {
    color: theme.custom.colors.confirmButton,
    position: 'absolute',
    top: '50%',
    left: '50%',
    marginTop: -12,
    marginLeft: -12,
  },
  formControl: {
    margin: theme.spacing(1),
    minWidth: 120,
  },
  colorAdorment: {
    width: 20,
    height: 20,
  },
});
